// extracted by mini-css-extract-plugin
export default {"BooleanListFeature":"wo_a big_b"};